import { logger } from 'lib/logger';
import { clearUploadedQueue } from 'reactApp/appHelpers/appHelpers';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { isOwnPublic, isPublicUploadEnabled } from 'reactApp/modules/public/public.selectors';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { showSnackbarAction } from 'reactApp/modules/snackbar/snackbar.actions';
import { SnackbarTypes } from 'reactApp/modules/snackbar/snackbar.types';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { sendGaUploader } from 'reactApp/modules/uploadList/uploadList.helpers';
import { filesPlural } from 'reactApp/utils/pluralHelpers';
import { call, cancel, delay, put, select, takeLatest } from 'redux-saga/effects';

import { resetProgress, uploaderTotalProgress } from './upload.module';

const sendGa = (successCount, failedCount, isOwnPublicRO) => {
    sendGaUploader('file', 'all');
    sendGaUploader(`file-newUploader`, 'all');

    const count = 100;

    const sendPart = (startI) => {
        if (startI >= failedCount && startI >= successCount) {
            return;
        }

        for (let i = startI; i < failedCount && i < startI + count; i++) {
            sendGaUploader('file', 'failed');
            sendGaUploader(`file-newUploader`, 'failed');
        }

        for (let i = startI; i < successCount && i < startI + count; i++) {
            sendGaUploader('file', 'success');
            sendGaUploader(`file-newUploader`, 'success');
            if (isOwnPublicRO) {
                sendGaUploader('file-own', 'success');
            }
        }

        setTimeout(() => sendPart(startI + count), 100);
    };

    setTimeout(() => sendPart(0), 100);
};

function* handleUploaderTotalProgress(action) {
    try {
        const { total, finished, failed, canceled } = action.payload;

        if (total > 0 && total !== finished) {
            return;
        }

        const isPhone = yield select(EnvironmentSelectors.isPhone);
        const storage = yield select(getCurrentStorage);
        const isOwnPublicRO: boolean =
            storage === EStorageType.public ? yield select(isOwnPublic) && !(yield select(isPublicUploadEnabled)) : false;
        const failedCount = failed + canceled;
        const successCount = total - failedCount;

        sendGa(successCount, failedCount, isOwnPublicRO);

        if (failedCount > 0) {
            if (successCount > 0) {
                yield put(
                    showSnackbarAction({
                        type: SnackbarTypes.failure,
                        id: 'file-upload-err',
                        text: `Успешно загружено ${successCount} ${filesPlural(successCount)} из ${total}`,
                        closable: true,
                    })
                );
            }
        } else {
            yield put(
                showSnackbarAction({
                    type: SnackbarTypes.success,
                    id: 'file-upload',
                    title: isPhone ? 'Файлы загружены' : undefined,
                    text: isPhone ? 'Проверяются антивирусом Касперского' : 'Загрузка успешно завершена',
                    closable: true,
                })
            );
        }

        yield delay(3000);

        if (storage === EStorageType.start) {
            yield call(clearUploadedQueue);
        }

        yield put(resetProgress());
    } catch (error) {
        logger.error(error);
        yield cancel();
    }
}

export function* watchUploaderRoot() {
    yield takeLatest(uploaderTotalProgress.toString(), handleUploaderTotalProgress);
}
